import { addNestedReducer } from '@lyra/app/core/functions/add-nested-reducer.function';
import { Action, createFeature } from '@ngrx/store';

import { SAVE_STATE } from './actions/questionnaire.actions';
import { saveQuestionnaireState } from './questionnaire-storage';
import * as goals from './reducers/goals.reducer';
import * as medicalQuestions from './reducers/medical-questions.reducer';
import * as medications from './reducers/medications.reducer';
import * as questionnaire from './reducers/questionnaire.reducer';
import * as question from './reducers/questions.reducer';
import * as survey from './reducers/survey.reducer';
import * as user from './reducers/user.reducer';
import * as womanHealth from './reducers/woman-health.reducer';
import { IQuestionnaireState } from './states/questionnaire.state';

export function reducer(state: IQuestionnaireState | undefined, action: Action): IQuestionnaireState {
  if (state === undefined) {
    state = questionnaire.initialState;
  }
  state = questionnaire.reducer(state, action);
  state = addNestedReducer(state, action, user);
  state = addNestedReducer(state, action, question);
  state = addNestedReducer(state, action, survey);
  state = addNestedReducer(state, action, goals);
  state = addNestedReducer(state, action, medications);
  state = addNestedReducer(state, action, medicalQuestions);
  state = addNestedReducer(state, action, womanHealth);

  return state;
}
let saveStateToLocalStorage = false;
/**
 * Whole-state localStorage persistence is DISABLED (MD-3080): we no longer mirror the entire store.
 * Gender + goal are persisted separately for the short-quiz → questionnaire prefill instead. The
 * machinery below is kept (not deleted) so it can be re-enabled by flipping this flag back to true.
 */
const PERSISTENCE_ENABLED = false;
/**
 * Mirror state changes into localStorage so they survive a store reset on later steps. Only persist
 * once a survey exists: otherwise the empty bootstrap/cleared state would overwrite a previously
 * saved good state before checkAndLoad can read it back.
 */
function withPersistence(inner: typeof reducer): typeof reducer {
  return (state, action) => {
    const next = inner(state, action);
    if (action.type === SAVE_STATE.type) {
      saveStateToLocalStorage = (action as ReturnType<typeof SAVE_STATE>).status;
    }
    if (next !== state && saveStateToLocalStorage && PERSISTENCE_ENABLED) {
      saveQuestionnaireState(next);
    }
    return next;
  };
}

export const questionnaireFeature = createFeature({
  name: questionnaire.featureKey,
  reducer: withPersistence(reducer),
});
